<template>
  <div>
    <div class="owner_title">金主公海信息</div>
    <!-- 筛选 -->
    <div class="task_filtrate" @click="show_filter_form()">
      <i class="iconfont icon-shaixuan1"></i>
      <span>筛选</span>
    </div>

    <!-- 筛选表单 -->
    <div class="filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="金主标签">
          <el-select
            v-model="filter_form.connectionlabel_id"
            placeholder="金主标签"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="(item, index) in lableList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filter_form.createtime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>

    <div class="task_box">
      <!-- 表格数据 -->
      <el-table :data="dataShow" border height="550">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="connectionlabel_text"
          label="金主标签"
          align="center"
          width="200"
          sortable
        >
          <template slot-scope="scope">
            <div class="sea_tag">
              <el-tag
                :key="item"
                v-for="item in scope.row.connectionlabel_text"
                type="info"
              >
                {{ item }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="300"
          :fixed="equipmentType == 1 ? false : 'right'"
        >
          <template slot-scope="scope">
            <div class="highSeas_box">
              <div @click="goMyOwnerk(scope.row)" class="myowner_btn">
                <i class="iconfont icon-zhuanru sea_icon"></i>
                转入我的金主
              </div>
              <div @click="historyRemark(scope.row)" class="remark_btn">
                <i class="iconfont icon-jilu sea_icon"></i>
                历史备注
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-show="equipmentType == 0 ? true : false"
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <el-pagination
        v-show="equipmentType == 1 ? true : false"
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 历史备注弹窗 -->
    <el-dialog
      :visible.sync="historyDialogVisible"
      title="历史备注"
      @close="cancelDialog"
    >
      <el-table :data="dataShowDialog" border>
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="departmentuser_name"
          sortable
          label="备注人"
          width="200"
        ></el-table-column>
        <el-table-column
          property="remark"
          sortable
          label="备注内容"
          width="200"
        ></el-table-column>
        <el-table-column
          property="createtime"
          sortable
          label="备注时间"
        ></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChangeDialog"
        @current-change="handleCurrentChangeDialog"
        :current-page="currentPageDialog"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSizeDialog"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalDialog"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import {
  connection_list,
  label_list,
  connectionremark_list,
  change_connection
} from "@/utils/owner";
export default {
  data() {
    return {
      ownerId: "", //金主所需部门id
      connectionList: [], //公海信息列表
      tagList: [], //标签列表
      historyList: [], //历史备注列表
      isFilterForm: true, //筛选按钮
      historyDialogVisible: false, //历史备注弹窗
      dataShow: [], // 当前页要显示的数据,
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      dataShowDialog: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageDataDialog: [], // 分页数据(全部数据已经分好页)
      pageNumDialog: 1, // 共几页
      pageSizeDialog: 10, // 每页显示数量
      currentPageDialog: 1, // 当前显示页码
      totalDialog: 1, // 总共多少条数据
      // 筛选
      filter_form: {
        name: "", //金主昵称
        qq_account: "", //金主QQ
        wx_account: "", //金主微信
        mobile: "", //金主电话号码
        createtime: "", //创建时间范围
        connectionlabel_id: "" //标签
      },
      lableList: "", //标签列表
      select_time_data: "",
      time_filter: "", //时间筛选
      equipmentType: 0 //设备 0-pc端 1移动端
    };
  },
  created() {
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
    } else {
      this.equipmentType = 0;
    }
    this.getConnectionList(); //任务中心列表
    this.getLabelList();
  },
  methods: {
    // 获取公海信息列表
    getConnectionList() {
      var that = this;
      that.getLabelList();
      let obj = {
        departmentuser_id: that.ownerId,
        page: 1,
        page_index: 10
      };
      connection_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.connectionList = res.data.data;
          that.calcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 获取标签列表
    getLabelList() {
      var that = this;
      label_list().then(res => {
        if (res.data.code == 1) {
          that.tagList = res.data.data;
          that.lableList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 筛选
    goSearch(val) {
      var that = this;
      var date1, date2;
      that.select_time_data = that.filter_form.createtime;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];
      if (val == 0) {
        var time1, time2;
        time1 = that.select_time_data[0];
        time2 = that.select_time_data[1];
        that.time_filter = time1 + " - " + time2;
        that.filter_form.createtime = that.time_filter;
      } else {
        if (date1 == undefined && date2 == undefined) {
          that.time_filter = "";
        } else {
          that.time_filter = date1 + " - " + date2;
        }
        that.filter_form.createtime = that.time_filter;
      }
      let obj = {
        departmentuser_id: that.ownerId,
        page: 1,
        page_index: 10,
        ...that.filter_form
      };

      connection_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.connectionList = res.data.data;
          that.calcPageData();
          that.filter_form.createtime = that.select_time_data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 获取历史备注
    historyRemark(val) {
      var that = this;
      that.historyDialogVisible = true;
      let obj = {
        departmentuser_id: that.ownerId,
        connection_id: val.id,
        page: 1,
        page_index: 10
      };
      connectionremark_list(obj).then(res => {
        if (res.data.code == 1) {
          that.totalDialog = res.data.data.length;
          that.historyList = res.data.data;
          that.calcPageDataDialog();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 转入我的金主
    goMyOwnerk(val) {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        connection_id: val.id
      };
      change_connection(obj).then(res => {
        if (res.data.code == 0) {
          that.$message.error(res.data.msg);
        } else {
          that.$router.push("/myOwner");
        }
      });
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 关闭弹窗触发
    cancelDialog() {
      this.goSearch(0);
    },
    calcPageData() {
      if (this.connectionList.length > 1) {
        this.pageNum =
          Math.ceil(this.connectionList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.connectionList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }

      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    },
    calcPageDataDialog() {
      if (this.historyList.length > 1) {
        this.pageNumDialog =
          Math.ceil(this.historyList.length / this.pageSizeDialog) || 1;
      }
      for (let i = 0; i < this.pageNumDialog; i++) {
        this.totalPageDataDialog[i] = this.historyList.slice(
          this.pageSizeDialog * i,
          this.pageSizeDialog * (i + 1)
        );
      }

      this.dataShowDialog = this.totalPageDataDialog[
        this.currentPageDialog - 1
      ];
    },
    handleSizeChangeDialog(val) {
      this.pageSizeDialog = val;
      this.calcPageDataDialog();
    },
    handleCurrentChangeDialog(val) {
      this.currentPageDialog = val;
      this.dataShowDialog = this.totalPageDataDialog[val - 1];
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}

.sea_tag .el-tag.el-tag--info {
  width: 90px;
  margin: 5px auto;
}
.remark_btn {
  width: 90px;
  height: 20px;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
}
.sea_icon {
  font-size: 12px;
}
.task_box {
  margin: 0 15px;
}
.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}
.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.filter_form {
  background: #ffffff;
  margin: 0px 16px;
  padding-top: 15px;
}

.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.myowner_btn {
  width: 110px;
  height: 20px;
  line-height: 20px;
  background: #157df8;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  border-radius: 17px;
  margin-right: 5px;
}
.highSeas_box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.sea_tag {
  text-align: center;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .task_box {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/owner/OwnerHighSeas.vue